import { useState } from "react"
import { Panel, ProgressBar } from "../components/ui"
import { useBakeryStore } from "../game/bakeryStore"
import { fmtInt } from "../game/format"
import { sfxFanfare, unlockAudioOnce } from "../game/music"

type QTab = "daily" | "weekly" | "server"

export default function QuestsPage() {
  const [tab, setTab] = useState<QTab>("daily")
  const store = useBakeryStore()
  const snap = store.snapshot
  const quests = store.quests
  const visible = quests.filter((q) => q.tab === tab)
  const isConnected = store.connected
  const claimableCount = store.claimableCount
  const bakeryLevel = snap?.bakery.level ?? 1
  const claimableFor = (t: QTab): number => quests.filter((q) => q.tab === t && q.done && !q.claimed && (q.lockedLevel === undefined || bakeryLevel >= q.lockedLevel)).length

  if (snap === null) {
    return (
      <div className="cb-page">
        <Panel className="hl center">
          <h2 className="cb-h" style={{ display: "flex", gap: 8, justifyContent: "center", alignItems: "center" }}>
            <span>🧭 Quests</span>
            {claimableCount > 0 && <span className="bk-badge" style={{ position: "static" }}>{claimableCount}</span>}
          </h2>
          <p className="dim small" style={{ margin: 0 }}>Complete tasks to earn Baker Credits.</p>
        </Panel>
        <div className="cb-tabs">
          {(["daily", "weekly", "server"] as QTab[]).map((t) => (
            <button type="button" key={t} onClick={() => setTab(t)} className={tab === t ? "cb-tab active" : "cb-tab"} aria-label={t === "daily" ? "Daily quests" : t === "weekly" ? "Weekly quests" : "Server quests"}>
              {t === "daily" ? "📅 Daily" : t === "weekly" ? "📆 Weekly" : "🏭 Server"}
              {claimableFor(t) > 0 && <span className="cb-tab-dot" aria-label={`${claimableFor(t)} claimable`} />}
            </button>
          ))}
        </div>
        <div className="cb-panel center small" role="status">Loading quests…</div>
      </div>
    )
  }

  return (
    <div className="cb-page">
      <Panel className="hl center">
        <h2 className="cb-h" style={{ display: "flex", gap: 8, justifyContent: "center", alignItems: "center" }}>
          <span>🧭 Quests</span>
          {claimableCount > 0 && <span className="bk-badge" style={{ position: "static" }}>{claimableCount}</span>}
        </h2>
        <p className="dim small" style={{ margin: 0 }}>{isConnected ? "Live progress from your bakery." : "Complete tasks to earn Baker Credits."}</p>
      </Panel>
      <div className="cb-tabs">
        {(["daily", "weekly", "server"] as QTab[]).map((t) => (
          <button type="button" key={t} onClick={() => setTab(t)} className={tab === t ? "cb-tab active" : "cb-tab"} aria-label={t === "daily" ? "Daily quests" : t === "weekly" ? "Weekly quests" : "Server quests"}>
            {t === "daily" ? "📅 Daily" : t === "weekly" ? "📆 Weekly" : "🏭 Server"}
            {claimableFor(t) > 0 && <span className="cb-tab-dot" aria-label={`${claimableFor(t)} claimable`} />}
          </button>
        ))}
      </div>
      <div className="cb-stack">
        {visible.map((q) => {
          const locked = q.lockedLevel !== undefined && (snap.bakery.level ?? 1) < q.lockedLevel
          return (
            <div key={q.id} className={q.done && !q.claimed ? "cb-card gold-glow" : q.claimed ? "cb-card maxed" : locked ? "cb-card muted" : "cb-card"}>
              <span className="cb-card-ico">{locked ? "🔒" : q.icon}</span>
              <div className="cb-card-body">
                <b>{q.title}</b>
                <small>{fmtInt(Math.min(q.cur, q.target))} / {fmtInt(q.target)}</small>
                <ProgressBar pct={q.pct} gold={q.done} />
                <small className="dim">+{q.reward} Baker Credits{q.lockedLevel != null ? ` · Unlocks at Bakery Level ${q.lockedLevel}` : ""}</small>
              </div>
              {q.claimed ? (
                <span className="cb-claimed">Claimed</span>
              ) : locked ? (
                <span className="cb-locked">Lv {q.lockedLevel}</span>
              ) : q.done ? (
                <button type="button" className="cb-buy" onClick={() => { unlockAudioOnce(); store.claimQuest(q.id); sfxFanfare() }}>Claim</button>
              ) : (
                <span className="cb-inprog">{q.pct > 0 ? Math.floor(q.pct) + "%" : "In progress"}</span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
